import { Button } from "@shared/ui";
import { RefreshCw } from "lucide-react";
import { WorkspacePromptEditor } from "../WorkspacePromptEditor";
import styles from "./creatorFitFlow.module.scss";

export function CreatorFitCriteria({
  workspaceId,
  requestId,
  initialHtml,
  savedRequestPrompt,
  contentKey,
  isSaving,
  saveVersion,
  onHtmlChange,
  onSave,
  showStale,
  isRerunningAll,
  onRerunAll,
}: {
  workspaceId: string;
  requestId?: string;
  initialHtml: string;
  savedRequestPrompt?: string;
  contentKey: string;
  isSaving: boolean;
  saveVersion: number;
  onHtmlChange: (html: string) => void;
  onSave?: (prompt: string) => void;
  showStale: boolean;
  isRerunningAll: boolean;
  onRerunAll: () => void;
}) {
  return (
    <section className={styles.panel}>
      <div className={styles.panelHead}>
        <div className={styles.titleLine}>
          <span className={styles.step}>1</span>
          <h2 className={styles.panelTitle}>Criteria</h2>
        </div>
        <p className={styles.panelHint}>
          This rubric is used for every creator you add.
        </p>
      </div>
      <div className={styles.panelBody}>
        <WorkspacePromptEditor
          key={requestId || "creator-fit"}
          moduleId="creator-fit"
          aiWorkspaceId={workspaceId}
          label="Criteria"
          hint="Saved on this workspace’s Creator Fit check."
          savedPrompt={initialHtml}
          committedPrompt={savedRequestPrompt}
          contentKey={contentKey}
          isSaving={isSaving}
          saveVersion={saveVersion}
          requestOnly
          onHtmlChange={onHtmlChange}
          onSave={onSave}
        />
      </div>
      {showStale ? (
        <div className={styles.stale}>
          <p>Criteria changed. Existing scores may be out of date.</p>
          <Button
            type="primary"
            size="small"
            icon={<RefreshCw size={13} />}
            loading={isRerunningAll}
            onClick={onRerunAll}
          >
            Rerun analysis on all
          </Button>
        </div>
      ) : null}
    </section>
  );
}
